

<script>
export default class Bullet{
  constructor(_bulletSprite, _bulletXCoord, _bulletYCoord, _bulletType, _bulletSpeed) {
    // bullet Types:
    // 1) normal enemy bullet
    // 2) cutoff Lazer
    this.bulletType = _bulletType;

    this.bulletSprite = _bulletSprite //bullet sprite
    this.bulletSpeed = _bulletSpeed; //how many times bullet moves UP in 1/100s
    this.bulletCoords = [_bulletXCoord,_bulletYCoord];
  }
}
</script>

